import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TrendingManager from '../components/admin/TrendingManager';
import '../styles/Admin.css';

const AdminTrending = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const initialSection = searchParams.get('section') || 'featured';

    useEffect(() => {
        const token = sessionStorage.getItem('adminToken');
        if (!token) {
            navigate('/admin/login');
        }
    }, [navigate]);

    return (
        <div className="admin-container">
            <div className="admin-header">
                <div className="header-left">
                    <h1>Trending Products</h1>
                    <p style={{ color: '#666', marginTop: '0.5rem' }}>
                        Configure which products appear in each category section on the homepage
                    </p>
                </div>
            </div>
            <TrendingManager initialSection={initialSection} />
        </div>
    );
};

export default AdminTrending;
